import * as T from '../constants/types';
import * as V from '../constants/variables';
import { getFiltersInitialState } from '../constants/filterStyles';

// ============================================================================
// INITIAL STATE GENERATION
// ============================================================================
// Первые 5 фильтров берутся из filterStyles.js
// Остальные фильтры (non-standardized) определены здесь
// ============================================================================

const filterStylesState = getFiltersInitialState();

export const initialState = {
    // Фильтры из filterStyles.js (Фаза 2: 10 фильтров PARKING + AGGREGATED)
    ...filterStylesState,

    // Остальные фильтры (TODO: миграция на filterStyles.js в фазах 2+)
    parkings1300Statuses: [ 'AGREED', 'PAID_FOR_PERIOD' ],
    // Тогл «Вместимость парковки» в легенде слоя «Парковки Whoosh»:
    // true — радиус пунсона по вместимости, false — единый радиус
    parkingCapacitySizing: true,
    LisboaZonesStatuses: [ 'Forbidden' ],
    parkingIsochrones: 200,
    startTrackDays: 7,
    finishTrackDays: 7,
    startTrackMode: V.ABS,
    finishTrackMode: V.ABS,
    poiStatuses: V.poiLegendValues,
    poiSources: V.poiSourceValues,
    serviceCentersIsochrones: 15,
    ServiceCentersStatuses: [ 'ACTIVE' ],
    isochronesWithScootersFilterStatuses: [ '0' ],
    correspondingMatrixPeriod: 'week',
    AnalyticArea: 1,
    aggFinishesStatuses: '2026',
    aggStartsStatuses: '2026',
    parkingsBookingsDateStatuses: 1,
    rechargingStatsPeriod: 'seasons', // 'seasons' | '1d' | '7d' | '30d' (DA-14276)
    currentScootersStatuses: [ '0', '1', '2' ],
    functionalAreasYandexUrentStatuses: [ 'Yandex', 'Urent', 'Jet', 'Lime', 'Bolt', 'SmartBike', 'Voi', 'LetsGo' ], // Все операторы включены по умолчанию
    scrTracksHourFrom: 0,  // DA-15115: начало выбранного диапазона часов на таймлайне суток (0..24)
    scrTracksHourTo: 24,   // DA-15115: конец диапазона; [0,24] = все сутки, треки не приглушаются
    scrTracksAvailableExecutors: [], // DA-15115: список исполнителей из загруженных тайлов треков [{id, name}] (режим всех треков)
    scrTracksSelectedExecutor: null, // DA-15115: выбранный исполнитель (employee_user_id) для фильтра слоя треков; null = все
    competitorsRestrictionZonesOperatorsDisabled: [], // Массив ОТКЛЮЧЕННЫХ пользователем операторов (зоны ограничений)
    competitorsRestrictionZonesAvailableOperators: [], // Динамически обновляется из загруженных тайлов (зоны ограничений)
    restrictionZonesV2Statuses: [ 'LIMITED', 'FORBIDDEN', 'PERMITTED', 'STOP_LIMIT', 'SPEED_LIMIT' ], // все типы V2 включены по умолчанию
    featureAreasStatuses: [ 'ACTIVE' ], // DA-15115: по умолчанию показаны только активные фиче-зоны
    showFictitiousZones: true, // Показывать фиктивные зоны по умолчанию
    showTechnicalZones: false, // Показывать технические зоны по умолчанию
    showProposedZones: true, // Показывать предлагаемые зоны по умолчанию
    showInvisibleZones: true, // Показывать невидимые зоны по умолчанию
    showForbiddenExistingZones: true, // Показывать существующие Зоны запрета катания по умолчанию
    showForbiddenProposedZones: false, // Показывать предлагаемые Зоны запрета катания по умолчанию
    showPermittedExistingZones: true, // Показывать существующие Зоны парковки по умолчанию
    showPermittedProposedZones: false, // Показывать предлагаемые Зоны парковки по умолчанию
    showRestrictionZonesV2Badges: false, // Показывать badge значки в зонах ограничений по умолчанию
    showFillZones: false, // Показывать полигональные заливки зон по умолчанию
    ridingZonesCompetitorsOperatorsDisabled: [], // Массив ОТКЛЮЧЕННЫХ операторов (зоны катания)
    ridingZonesCompetitorsAvailableOperators: [], // Динамически обновляется из загруженных тайлов (зоны катания)
    trackStartsCompetitorsAvailableOperators: [], // Динамически обновляется из загруженных тайлов (агрегированные старты)
    oaCompetitorsAvailableOperators: [], // Динамически обновляется из загруженных тайлов (старты по операционным зонам)
    competitorsParkingsOperatorsDisabled: [], // Массив ОТКЛЮЧЕННЫХ операторов (парковки конкурентов) (DA-13627)
    competitorsParkingsAvailableOperators: [], // Динамически обновляется из загруженных тайлов (парковки конкурентов) (DA-13627)
    competitorsFleetTransfersOperatorsDisabled: [], // Массив ОТКЛЮЧЕННЫХ операторов (переброски флота) (DA-13611)
    competitorsFleetTransfersAvailableOperators: [], // Динамически обновляется из загруженных тайлов (переброски флота) (DA-13611)
    competitorsFleetTransfersShowScooters: true,    // Показывать переброски с самокатами (DA-13611)
    competitorsFleetTransfersShowBicycles: true,    // Показывать переброски с велосипедами (DA-13611)
    competitorsFleetTransfersDateMode: false,        // Режим фильтра по дате: false = диапазон, true = конкретная дата (DA-13611)
    competitorsFleetTransfersSelectedDate: null,     // Выбранная дата фильтра 'YYYY-MM-DD' (DA-13611)
    competitorsFleetTransfersAvailableDates: [],     // Динамически обновляется из загруженных тайлов (DA-13611)
    competitorsFleetTransfersDateOperators: {},      // Карта 'YYYY-MM-DD' → [операторы] для штрихов таймлайна (DA-14953)
    competitorsFleetTransfersRangeFrom: null,        // Режим «Выбрать диапазон»: начало (ISO-дата); null = весь период (DA-14953)
    competitorsFleetTransfersRangeTo: null,          // Режим «Выбрать диапазон»: конец (ISO-дата); null = весь период (DA-14953)
    competitorsZonesChangesPeriod: 7,                  // Выбранный период фильтра в днях: 7 | 14 | 30 (DA-14686)
    competitorsZonesChangesOperatorsDisabled: [],      // Массив ОТКЛЮЧЕННЫХ операторов (изменения зон конкурентов) (DA-14686)
    competitorsZonesChangesAvailableOperators: [ 'Yandex', 'Urent', 'Jet', 'Lime', 'Bolt', 'Voi', 'LetsGo', 'Eleven' ], // Fallback до загрузки тайлов; обновляется динамически (DA-14686)
    competitorsZonesChangesDisabledTypes: [],          // Массив ОТКЛЮЧЕННЫХ типов: new|deleted|geom_changed|attrs_changed (DA-14686)
    competitorsParkingsChangesPeriod: 7,               // Выбранный период фильтра в днях: 7 | 14 | 30 (DA-15432)
    competitorsParkingsChangesOperatorsDisabled: [],    // Массив ОТКЛЮЧЕННЫХ операторов (изменения парковок конкурентов) (DA-15432)
    competitorsParkingsChangesAvailableOperators: [ 'Yandex', 'Urent', 'Jet', 'Lime', 'Voi', 'LetsGo', 'Eleven', 'SmartBike' ], // Fallback до загрузки тайлов (DA-15432)
    competitorsParkingsChangesDisabledTypes: [],       // Массив ОТКЛЮЧЕННЫХ типов: new|presumed_deleted|moved|attrs_changed (DA-15432)
    osmAdminBoundariesLevelsDisabled: [],      // Массив ОТКЛЮЧЕННЫХ уровней admin_level (DA-13054)
    osmAdminBoundariesAvailableLevels: [],     // Динамически обновляется из загруженных тайлов (DA-13054)
    osmAdminBoundariesShowLabels: true,        // Подписи административных единиц, по умолчанию включены (DA-13054)
    AlertsTypesStatuses: 1,
    AlertsDeviceStatuses: 1,
    classifiedParkingsWeekdaysStatuses: 0,
    classifiedParkingsRebalancedWeekdaysStatuses: 0,
    classifiedParkingDayPartStatuses: 1,
    classifiedParkingDayPartRebalancedStatuses: 1,
    aggDiffStartsFinishesStatuses: '2026',
    speedLimitsStatuses: [ 'STOP_LIMIT', 'SPEED_LIMIT', 'STOP_LIMIT_with_pause' ],
    ParkingsAlertsPointsDeviceStatuses: [ 'PHONE', 'DEVICE' ],
    parkingsAlertsPointsPeriodStatuses: 3,
    parkingsAlertsPointsTypeErrorStatuses: 12,
    tapsDays: 7,
    opensDays: 7,
    tapsMode: V.ABS,
    opensMode: V.ABS,
    tapsNoStartsDays: 7,
    OpensToStartDays: 7,
    CompetitorsPrefix: 'leadership',
    CompetitorsDays: 7,
    Competitor: 'whoosh',
    CompetitorRotationV2: 'whoosh',
    panoramasStatuses: [],
    cityBoundariesOnlyActive: false,           // Слой «Границы города»: показывать только активные у Whoosh регионы (region_status = ACTIVE)
    oaCompetitorsDays: 7,
    oaRotationDays: 7,
    oaRotationV2Days: 7,
    showRotationStatuses: [],
    showRotationV2Statuses: [],
    oaRotationMetric: 'rotation',                  // DA-12016: 'rotation' | 'trips' | 'fleet'
    oaRotationAvailableOperators: [],              // DA-12016: динамически обновляется из тайлов
    oaRotationOperator: 'whoosh',                  // DA-12016: выбранный оператор (радиопереключатель)
    sbWithErrorsStatuses: V.SbWithErrorsValues,
    lostDevicesStatuses: V.LostDevicesValues.filter(v => v !== 'DELETED'), // DA-12966; DELETED по умолчанию выключен
    lostDevicesShowServiceCenter: true, // DA-12966: показывать потери рядом с СЦ
    lostDevicesH3Category: 'cnt_lost_found', // DA-15988: категория гекс-слоя (счётчик), радиокнопки
    lostDevicesH3Zoom: 'auto', // DA-12966: используется только DynamicGradientLegend для отображения масштаба
    ghostDevicesShowAccuracy: false, // Вероятные призраки: круги точности показанной позиции
    ghostDevicesShowFinishAccuracy: true, // Вероятные призраки: круги точности финиша (самокат ↔ телефон)
    ghostDevicesShowStandBy: true, // Вероятные призраки: самокаты в STAND_BY
    ghostDevicesShowChangeBattery: true, // Вероятные призраки: самокаты в CHANGE_BATTERY
    // DEV → Поиск лостов: тумблеры классов, кругов точности, финиша и метки кражи
    lostSearchShowA: true,  // умер на финише
    lostSearchShowB: true,  // выбросы координат
    lostSearchShowC: true,  // сместился < 1 км
    lostSearchShowD1: true, // разрядился на финише
    lostSearchShowD2: true, // пропал с живой батареей
    lostSearchShowE: true,  // уехал > 1 км
    lostSearchShowRadius: false, // круги точности точек: по умолчанию скрыты, показываются по клику
    lostSearchShowZone: true,   // зона поиска вокруг якоря
    lostSearchShowFinish: true, // финиш последней поездки
    lostSearchShowTheft: true,  // двойной кружок на подозрении в краже
    operationAreaErrTypes: V.OperationAreaErrTypeValues,  // DA-14587: типы ошибок геометрии операционных зон
    functionalAreaErrTypes: V.OperationAreaErrTypeValues, // DA-14587: типы ошибок геометрии функциональных зон
    opAreaErrEnabled: true,                               // DA-14587: группа операционных зон включена
    funcAreaErrEnabled: true,                             // DA-14587: группа функциональных зон включена
    parkingProposalsShowHulls: true,                      // DA-15433: полигоны спроса
    parkingProposalsShowPoints: true,                     // DA-15433: точки парковок + круги радиуса
    tapsOpensHistYear: 2026,
    tapsOpensHistMode: V.ABS,
    tapsOpensHistPrefix: 'taps',
    aggScootersDowntimePeriodStatuses: 7,
    downtimeStatuses: [ '0', '1', '2', '3', '4', '5', '6', '7' ],
    walkscoreMetric: 'r_all', // DA-14919: крашенная метрика WalkScore (15 категорий + 5 групп + r_all)
    walkscoreH3Zoom: 'auto', // DA-14919: H3 zoom WalkScore ('auto' → функция берёт z-1, диапазон 6–10)
    // DA-16000: слой «Wifi точки» — представление ('points' | 'h3') и уровень H3 в режиме агрегата.
    // По умолчанию агрегат: точечное представление включается с 12-го зума и на масштабе
    // города не показало бы ничего, а тайл там несёт до 30 тыс. фич.
    wifiApMode: 'h3',
    wifiApH3Zoom: 'auto',
    aggTripsAugustH3Zoom: 'auto', // Используется только легендой для отображения масштаба
    aggTripsAugustYear: '2026',
    aggTracksAugustH3Zoom: 'auto', // Управляет параметром h3_zoom в запросе тайлов
    adminAggTracksV2H3Zoom: 'auto', // H3 zoom для слоя "Агрегированные треки за последние 7 дней"
    adminAggTracksV2VehicleType: 'all', // 'all' | 'scooters' | 'bikes'
    adminAggTracksV2Period: 'week', // 'week' | 'weekdays' | 'weekends'
    // DA-15259: треки по моделям тарификации. Период уходит query-параметром в MVT-функцию.
    aggTracksCohortH3Zoom: 'auto',
    aggTracksCohortType: 'all', // значение из V.aggTracksCohortValues
    aggTracksCohortPeriod: 'week', // 'week' | 'weekdays' | 'weekends'
    aggTracksCohortMode: 'abs', // 'abs' | 'share' — абсолют или доля когорты в гексагоне
    // DA-15415: треки по когортам пользователей. Период и разрез уходят query-параметрами
    // в MVT-функцию: разрез определяет, какие колонки бакетов приедут в тайле.
    userCohortsH3Zoom: 'auto',
    userCohortsDimension: 'age', // 'age' | 'gender' | 'tenure' | 'verification'
    userCohortsType: 'age_age18_45', // значение листа из V.userCohortsValues
    userCohortsPeriod: 'week', // 'week' | 'weekdays' | 'weekends' | метка месяца (may2025, …)
    userCohortsMode: 'abs', // 'abs' | 'share' — абсолют или доля бакета в гексагоне
    // DA-14786: помесячный слой треков. Month по умолчанию — последний завершившийся месяц ('YYYY-MM').
    adminAggTracksMonthlyH3Zoom: 'auto',
    adminAggTracksMonthlyVehicleType: 'all', // 'all' | 'scooters' | 'bikes'
    adminAggTracksMonthlyPeriod: 'week', // 'week' | 'weekdays' | 'weekends'
    adminAggTracksMonthlyMonth: (() => {
        const d = new Date();
        d.setDate(1);
        d.setMonth(d.getMonth() - 1); // предыдущий завершившийся месяц
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    })(),
    rechargingStatsH3Zoom: 'auto',
    regToTripH3Zoom: 'auto', // H3 zoom для слоя "Конверсия из регистраций в старты" (DA-13570)
    h3GridH3Zoom: 'auto', // H3 zoom для слоя "Адреса гексагонов H3" (DA-13776)
    rebalanceForecastTabaMode: 'taba', // 'forecast' | 'taba' — режим объединённого слоя Таба/Форкаст
    rebalanceMinGapUpEnabled: true, // фильтр по минимальному порогу избытка (countGapUp/percentageGapUp из настроек города)
    rebalanceMinGapDownEnabled: true, // фильтр по минимальному порогу дефицита (countGapDown/percentageGapDown из настроек города)
    rebalanceOnlyEmptyEnabled: false, // показывать только парковки без самокатов (cnt_scooters = 0)
    // rebalance-chains: Статистика цепочек трипов
    chainStatsSizeMetric: 'median', // 'median' | 'max' — по какой глубине цепочки взвешивать размер точки/фильтр слайдера
    chainStatsMinCount: 5, // слайдер легенды "Длина цепочки не менее" (фильтр по chainStatsSizeMetric-полю), диапазон 0-15 шаг 1
    chainStatsMinTotalTrips: 0, // слайдер "Число поездок через парковку не менее" (фильтр по total_trips), индекс CHAIN_STATS_MIN_TOTAL_TRIPS_STOPS, 0 — выключен
    chainStatsSelectedParkingId: null, // корень открытой цепочки (уровень 1), null — вся сеть
    chainStatsSelectedParkingStats: null, // {chain_count, max_chain_length, median_chain_length} выбранной парковки — для подписи в легенде
    chainStatsHighlightedNodeId: null, // подсветка узла/ребра внутри цепочки (уровень 2)
    // DA-14308: Выбросы GPS-треков (H3) / Гео вылеты
    routeAnomaliesH3Zoom: 'auto',         // H3 zoom, передаётся как h3_zoom в запрос тайлов
    routeAnomaliesPeriod: '1d',           // '1d' | '7d' | '30d' | 'all' — фильтр по периоду (DA-14308)
    routeAnomaliesSrc: 'all',             // 'all' | 'gps' | 'lbs' | 'phone_gps' | 'ble_s'
    routeAnomaliesMetric: 'median_dist',  // 'median_dist' | 'cnt' | 'bin'
    routeAnomaliesBin: 'lt_10',           // активный bin при metric='bin'
    routeAnomaliesWeighted: false,        // true → cnt_<src>_<bin> / cnt_<src> (paint на фронте)
    routeAnomaliesDirection: 'from',      // 'from' | 'to' — откуда/куда (переключает MVT endpoint)
    // DA-13733: предложения по развитию сети в слое «Загрузка зарядных объектов» (выключены по умолчанию)
    chargingProposals: false,
    chargingProposalsVariant: 'plan',    // 'walk' — пешком 1,5 км | 'scooter' — самокат 15 мин | 'plan' — согласованный план
    // DA-13733: действующие объекты и их подрядчики (contractor) — по умолчанию все видны
    chargingObjects: true,
    chargingAksel: true,
    chargingInnovat: true,
    // DA-15040 — слой «ДТП СИМ» (клиентская фильтрация + раскраска)
    simAccidentsPeriodMode: 'all', // 'all' | '2025' | '2026' | 'range' | 'date'
    simAccidentsDate: null,        // ISO-дата выбранного дня (режим 'date')
    simAccidentsYear: 2026,        // год в степпере таймлайна (режим 'date')
    // DA-14953 — режим 'range': границы диапазона (ISO-даты); null = весь доступный период
    simAccidentsRangeFrom: null,
    simAccidentsRangeTo: null,
    simAccidentsCategorizeBy: 'accident_type', // 'accident_type' | 'operator' | 'offender'
    simAccidentsKilled: false,     // тогл: есть погибшие
    simAccidentsInjured: false,    // тогл: есть раненые
    simAccidentsChildren: false,   // тогл: дети на СИМ
    urbanTypologyExtrudeBuildings: false, // DA-15309: 3D-экструзия зданий по этажности
    urbanTypologyColorMode: 'class',      // DA-15309: покраска зданий — 'class' | 'levels' | 'population'
    urbanTypologyShowZoneFill: true,      // заливка зон слоя «Типология территорий» (тумблер «Типология зон»)
    urbanTypologyShowBlocks: false,       // подслой «Границы кварталов» слоя «Типология территорий»
    // DA-15980: A/B-источник слоя «Землепользование» — 'old' (good_bad_area_mvt, по
    // умолчанию) | 'new' (urban_zones_classified через urban_typology_zones_mvt)
    landuseSource: 'old',
    // DA-15980: шторка сравнения источников — вторая карта поверх основной
    landuseCompare: false,
};

export const mapFilters = (state = initialState, { type, payload }) => {
    switch (type) {
        case T.CHANGE_MAP_FILTERS:
            return { ...state, ...payload };
        default:
            return state;
    }
};
